import { render, staticRenderFns } from "./PassSafeguardIdVerify.vue?vue&type=template&id=b71a9ce0&"
import script from "./PassSafeguardIdVerify.vue?vue&type=script&lang=js&"
export * from "./PassSafeguardIdVerify.vue?vue&type=script&lang=js&"
import style0 from "./PassSafeguardIdVerify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports